import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, TextField, RadioGroup, Radio, FormGroup } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepThree(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect(() => {
        if (props.datas.sousTraitant) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Lorsque vous louez en location à court et moyen terme, faites vous appel à des entreprises ou des sous-traitant locaux (ménage, linge, livraison, gestion, accueil…) ?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        defaultValue={props.datas.sousTraitant}
                        name="radio-buttons-group">
                        <FormControlLabel
                            value="Oui Toujours"
                            control={<Radio name='sousTraitant'
                                onChange={(e) => handleChange(e)} />}
                            label="Oui Toujours" />
                        <FormControlLabel
                            value="Oui Parfois"
                            control={<Radio name='sousTraitant'
                                onChange={(e) => handleChange(e)} />}
                            label="Oui Parfois" />
                        <FormControlLabel
                            value="Non"
                            control={
                                <Radio name='sousTraitant'
                                    onChange={(e) => handleChange(e)} />}
                            label="Non" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons} />
        </>
    )
}